import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse, AxiosError } from "axios";
import { TerminalDTO } from "../types/terminalDTO";
import Problem from "../types/problem";
import apiClient from "../main/apiClient";

const useFetchTerminals = (organisationId: string) => {
    return useQuery<TerminalDTO[], AxiosError>({
        queryKey: ["terminal"],
        queryFn: () =>
          apiClient.get(`/organisation/${organisationId}/terminal`).then((resp) => resp.data),
    });
}

const useFetchTerminalsForUnit = (organisationId: string, unitId: string) => {
  return useQuery<TerminalDTO[], AxiosError>({
      queryKey: ["terminal"],
      queryFn: () =>
        apiClient.get(`/organisation/${organisationId}/unit/${unitId}/terminal`).then((resp) => resp.data),
  });
}

const useFetchTerminal = (organisationId: string, unitId: string, id: string) => {
  return useQuery<TerminalDTO, AxiosError>({
    queryKey: ["terminal", id],
    queryFn: () =>
      apiClient.get(`/organisation/${organisationId}/unit/${unitId}/terminal/${id}`).then((resp) => resp.data),
  });
}

const useUpdateTerminal = (organisationId: string, unitId: string) => {
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse, AxiosError<Problem>, TerminalDTO>({
    mutationFn: (terminal) => apiClient.put(`/organisation/${organisationId}/unit/${unitId}/terminal`, terminal),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["terminal"] });
    },
  });
};

const useAddTerminal = (orgId: string, unitId: string, setTerminalState: (terminal: TerminalDTO) => void) => {
  const queryClient = useQueryClient();
  return useMutation<AxiosResponse, AxiosError<Problem>, TerminalDTO>({
    mutationFn: (terminal) => apiClient.post(`/organisation/${orgId}/unit/${unitId}/terminal`, terminal),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["unit"] });
    },
    onError: (error, variables) => {
      console.log(error);
      setTerminalState(variables);
    }
  });
};

export { useFetchTerminals, useFetchTerminalsForUnit, useFetchTerminal, useUpdateTerminal, useAddTerminal }